
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ModalBody',
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    className: {
      type: String,
      default: 'modal-body'
    }
  }
})
